import AbstractComponent from "./abstract-component";

export default class Header extends AbstractComponent {

    constructor(el) {
        super(el)
        this.DOM = {};
        this.profileOpen = false;
        this.initDomElements();
        this.iniEvents();
    }

    initDomElements() {
        this.video = this.$el.querySelector('video');
        this.DOM.profileBar = this.$el.querySelector('[data-profile-bar]');
        this.DOM.profileTrigger = this.$el.querySelector('[data-profile-trigger]');
        this.DOM.profilePopin = this.$el.querySelector('[data-profile-popin]');
        this.DOM.profileCloses = this.$el.querySelectorAll('[data-profile-close]');
        this._playVideoOnIntent = null;
        this._onProfileTriggerClick = null;
        this._onEscape = null;
    }

    iniEvents() {
        this._playVideoOnIntent = () => this.playVideo();
        document.addEventListener('click', this._playVideoOnIntent, { passive: true });
        document.addEventListener('touchstart', this._playVideoOnIntent, { passive: true });
        document.addEventListener('touchmove', this._playVideoOnIntent, { passive: true });
        document.addEventListener('scroll', this._playVideoOnIntent, { passive: true });
        document.addEventListener('keydown', this._playVideoOnIntent);

        if (this.DOM.profileTrigger && this.DOM.profilePopin) {
            this._onProfileTriggerClick = (e) => {
                e.preventDefault();
                this.toggleProfilePopin();
            };
            this.DOM.profileTrigger.addEventListener('click', this._onProfileTriggerClick);
            this.DOM.profileCloses.forEach((el) => {
                el.addEventListener('click', () => this.closeProfilePopin());
            });
            this._onEscape = (e) => {
                if (e.key === 'Escape' && this.profileOpen) {
                    this.closeProfilePopin();
                }
            };
            document.addEventListener('keydown', this._onEscape);
        }
    }

    toggleProfilePopin() {
        if (this.profileOpen) {
            this.closeProfilePopin();
        } else {
            this.openProfilePopin();
        }
    }

    openProfilePopin() {
        if (!this.DOM.profilePopin) return;
        this.profileOpen = true;
        this.DOM.profilePopin.hidden = false;
        requestAnimationFrame(() => {
            this.DOM.profilePopin.classList.add('is-open');
        });
        this.DOM.profileTrigger?.setAttribute('aria-expanded', 'true');
        this.app.emit('disable-scroll');
    }

    closeProfilePopin() {
        if (!this.DOM.profilePopin || !this.profileOpen) return;
        this.profileOpen = false;
        this.DOM.profilePopin.classList.remove('is-open');
        this.DOM.profileTrigger?.setAttribute('aria-expanded', 'false');
        const onEnd = () => {
            this.DOM.profilePopin.hidden = true;
            this.DOM.profilePopin.removeEventListener('transitionend', onEnd);
        };
        this.DOM.profilePopin.addEventListener('transitionend', onEnd);
        setTimeout(() => {
            if (!this.profileOpen) this.DOM.profilePopin.hidden = true;
        }, 400);
        this.app.emit('enable-scroll');
    }

    playVideo() {
        if (this.video && this.video.paused) {
            this.video.play();
        }
    }

    destroy() {
        this.closeProfilePopin();
        if (this._playVideoOnIntent) {
            document.removeEventListener('click', this._playVideoOnIntent);
            document.removeEventListener('touchstart', this._playVideoOnIntent);
            document.removeEventListener('touchmove', this._playVideoOnIntent);
            document.removeEventListener('scroll', this._playVideoOnIntent);
            document.removeEventListener('keydown', this._playVideoOnIntent);
        }
        if (this._onProfileTriggerClick && this.DOM.profileTrigger) {
            this.DOM.profileTrigger.removeEventListener('click', this._onProfileTriggerClick);
        }
        if (this._onEscape) {
            document.removeEventListener('keydown', this._onEscape);
        }
    }
}
